<template>
  <div class="select-number-list__wrap">
    <div class="select-number-list__wrap--item" v-for="(item) in currentSelectedOptions" :key="item.id">
      <div class="select-number-list__wrap--item__right">
        <InputNumberWithPopover :data-tracking='dataTracking' v-model="item.number" size="lg" :min="item.min"
                                controls-position="both"
                                :max="item.max" :label="`${item.name} ${item.desc} Select the number of plans`"
                                :disabled="item.disabled"
                                :data-testid="`checkout-input-license-${item.id}`" />
        <div class="select-number-list__wrap--item__number">
          {{ displayUnit }} x {{ optionList[0].desc}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Select Number List Component
 *
 * @props {{ id: string, name: string, desc: string, tooltip: string, min: number, max: number, disabled: boolean }} optionList - All select option list
 * @props {{ id: string, number: number }} modelValue - Selected option list
 * @props { function } beforeChange - Before change item
 * @props { string } title - Title of select number list
 * @method newItem - Add new item
 */
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import { translation } from '@/plugins/i18n';

export default {
  name: 'NumberList',
  components: {InputNumberWithPopover},
  props: {
    dataTracking: {
      type: Object,
      required: false,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    optionList: {
      type: Array,
      default: () => [],
    },
    beforeChange: {
      type: Function,
      default: null,
    },
    title: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: () => {
        return translation('billing.planform.unit.number').toLowerCase()
      },
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      currentSelectedOptions: []
    };
  },
  computed: {
    canSelectOptions() {
      return this.optionList.filter((item) => {
        return !this.currentSelectedOptions.some(option => option.id === item.id);
      });
    },
    watchCurrentSelectedOptions() {
      return JSON.parse(JSON.stringify(this.currentSelectedOptions));
    },
    displayUnit() {
      return this.unit || this.$t('billing.planform.unit.number').toLowerCase();
    }
  },
  watch: {
    watchCurrentSelectedOptions: {
      handler(nv, ov) {
        if (this.beforeChange && !this.updating) {
          // Process data updates outside the component.
          this.beforeChange(nv, ov, (result) => {
            this.$emit('update:modelValue', result.map(({ id, number }) => ({ id, number })))
            this.$nextTick(() => {
              this.initData();
            })
          });
        } else {
          this.$emit('update:modelValue', nv.map((item) => (item)));
        }
      },
      deep: true,
    },
  },
  methods: {
    initData() {
      this.updating = true;
      this.currentSelectedOptions = this.modelValue.map((item) => {
        const option = this.optionList.find(option => option.id === item.id);
        return {
          ...option,
          ...item,
        };
      });
      this.$nextTick(() => {
        this.updating = false;
      });
    },
    newItem() {
      this.canSelectOptions.length && this.currentSelectedOptions.push({
        ...this.canSelectOptions[0],
        number: 1,
      });
    },
  },
  created() {
    this.initData()
  },
}
</script>
<style lang="scss">
.select-number-list {
  &__wrap {
    margin: 0;

    &--item {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      &__right {
        display: flex;
        align-items: center;
      }

      &__number {
        font-weight: 500;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        margin-left: 8px;
      }
    }
  }
}
</style>
